import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { TextKey } from '@mews-commander/enums';
import { FormCheckboxGroupField, lt } from '@mews/framework';
import { FormFields, FormValues, OptionsNames } from '../../../schema';

export const OptionsField: FC = () => {
    const { setValue, getValues, watch } = useFormContext<FormValues>();
    const promotedServiceId = watch(FormFields.PromotedServiceId);

    useEffect(() => {
        const { promotedServiceAssignmentOptions } = getValues();
        setValue(FormFields.Options, promotedServiceAssignmentOptions, { shouldValidate: true });
    }, [getValues, promotedServiceId, setValue]);

    return (
        <FormCheckboxGroupField
            required
            label={lt(TextKey.OfferToCustomer)}
            options={[
                {
                    name: FormFields.Options,
                    value: OptionsNames.InBookingEnging,
                    label: lt(TextKey.PromotedServiceAssignmentOptionsOfferInBookingEngine),
                },
                {
                    name: FormFields.Options,
                    value: OptionsNames.DuringOnlineCheckin,
                    label: lt(TextKey.PromotedServiceAssignmentOptionsOfferDuringOnlineCheckIn),
                },
            ]}
            name={FormFields.Options}
        />
    );
};
